export const QUESTION_CONTACT = [
    {
        id: 1,
        question: 'Nombres y apellidos',
        value: 'name'
    },
    {
        id: 2,
        question: 'Número telefónico',
        value: 'phone'
    },
    {
        id: 3,
        question: 'Correo electrónico',
        value: 'email'
    },
    {
        id: 4,
        question: 'Mensaje',
        value: 'message'
    }
]